import { ContentData } from "../../src/apis/stateful-content";
import { ColumnTypes } from "../../src/components/stateful-content/stateful-table/column-types";
const fs = require("fs");
const output = `${__dirname}/../../resources/generated-mock-data/`;
import { StatusType } from "@trumpf/ux.ui-widgets/dist/collection/components/status/status-types";

const ordered: StatusType = "ORDER_ORDERED";
const inProgress: StatusType = "ORDER_IN_PROGRESS";
const cancelled: StatusType = "ORDER_CANCELLED";
const partlyDelivered: StatusType = "ORDER_PARTLY_SENT";
const complete: StatusType = "ORDER_COMPLETE";
const received: StatusType = "ORDER_RECEIVED";
const unknown: StatusType = "ORDER_UNKNOWN";

const response: ContentData = {
    totalCount: 31,
    filteredCount: 31,
    labelCount: "Treffer",
    schema: {
        orderNum: {
            type: ColumnTypes.Text,

            sortable: true,
            "primary-mobile": true,
        },
        status: {
            type: ColumnTypes.Status,
            sortable: true,
            "primary-mobile": false,
        },
        date: {
            type: ColumnTypes.Date,

            sortable: true,
            "primary-mobile": false,
        },
        entryPoint: {
            type: ColumnTypes.Text,

            sortable: true,
            "primary-mobile": false,
        },
        position: {
            type: ColumnTypes.Text,

            sortable: true,
            "primary-mobile": false,
        },
        orderSum: {
            type: ColumnTypes.Text,

            sortable: true,
            "primary-mobile": false,
        },
        machineNum: {
            type: ColumnTypes.TextWithConditionalTooltip,

            sortable: true,
            "primary-mobile": false,
        },
        details: {
            type: ColumnTypes.DetailLink,

            sortable: false,
            "primary-mobile": false,
        },
    },
    items: [
        {
            orderNum: "38613864 (Order-14.07.2022)",
            status: ordered,
            date: "2020-06-20",
            entryPoint: "E-Shop",
            position: "10",
            orderSum: "5.012,57 €",
            machineNum: ["TruLaser Cell 1005", "TruLaser Fiber 5030"],
            details:
                "https://www.trumpf.com/de_DE/mytrumpf/meine-bestellungen/?tx_mytrumpf_orderhistory%5BorderNumber%5D=38602841&tx_mytrumpf_orderhistory%5Baction%5D=order&tx_mytrumpf_orderhistory%5Bcontroller%5D=OrderHistory",
        },
        {
            orderNum: "38605889 (Order-11.07.2022)",
            status: inProgress,
            date: "2020-01-20 17:32:33",
            entryPoint: "Sonstige",
            position: "3",
            orderSum: "824,80 €",
            machineNum: ["TruLaser Cell 1005"],
            details:
                "https://www.trumpf.com/de_DE/mytrumpf/meine-bestellungen/?tx_mytrumpf_orderhistory%5BorderNumber%5D=38602841&tx_mytrumpf_orderhistory%5Baction%5D=order&tx_mytrumpf_orderhistory%5Bcontroller%5D=OrderHistory",
        },
        {
            orderNum: "38602841 (Order-08.07.2022",
            status: cancelled,
            date: "2020-01-20 17:32:33",
            entryPoint: "Sonstige",
            position: "1",
            orderSum: "635,90 €",
            machineNum: "TruLaser Fiber 5030",
            details:
                "https://www.trumpf.com/de_DE/mytrumpf/meine-bestellungen/?tx_mytrumpf_orderhistory%5BorderNumber%5D=38602841&tx_mytrumpf_orderhistory%5Baction%5D=order&tx_mytrumpf_orderhistory%5Bcontroller%5D=OrderHistory",
        },
        {
            orderNum: "38592379 (Order-07.07.2022)",
            status: partlyDelivered,
            date: "2022-06-20 17:32:33",
            entryPoint: "EDI",
            position: "1",
            orderSum: "1.570,80 €",
            machineNum: "--",
            details:
                "https://www.trumpf.com/de_DE/mytrumpf/meine-bestellungen/?tx_mytrumpf_orderhistory%5BorderNumber%5D=38602841&tx_mytrumpf_orderhistory%5Baction%5D=order&tx_mytrumpf_orderhistory%5Bcontroller%5D=OrderHistory",
        },
        {
            orderNum: "38591358 (Order-29.06.2022)",
            status: complete,
            date: "2023-06-20 17:32:33",
            entryPoint: "E-Shop",
            position: "1",
            orderSum: "1.120,80 €",
            machineNum: "--",
            details:
                "https://www.trumpf.com/de_DE/mytrumpf/meine-bestellungen/?tx_mytrumpf_orderhistory%5BorderNumber%5D=38602841&tx_mytrumpf_orderhistory%5Baction%5D=order&tx_mytrumpf_orderhistory%5Bcontroller%5D=OrderHistory",
        },
        {
            orderNum: "38591358 (Order-29.06.2022)",
            status: received,
            date: "2021-06-20 17:32:33",
            entryPoint: "E-Shop",
            position: "1",
            orderSum: "1.120,80 €",
            machineNum: "--",
            details:
                "https://www.trumpf.com/de_DE/mytrumpf/meine-bestellungen/?tx_mytrumpf_orderhistory%5BorderNumber%5D=38602841&tx_mytrumpf_orderhistory%5Baction%5D=order&tx_mytrumpf_orderhistory%5Bcontroller%5D=OrderHistory",
        },
        {
            orderNum: "38591358 (Order-29.06.2022)",
            status: unknown,
            date: "2020-06-05 17:32:33",
            entryPoint: "E-Shop",
            position: "1",
            orderSum: "1.120,80 €",
            machineNum: "--",
            details:
                "https://www.trumpf.com/de_DE/mytrumpf/meine-bestellungen/?tx_mytrumpf_orderhistory%5BorderNumber%5D=38602841&tx_mytrumpf_orderhistory%5Baction%5D=order&tx_mytrumpf_orderhistory%5Bcontroller%5D=OrderHistory",
        },
    ],
};

const emptyResponse: ContentData = {
    totalCount: 0,
    filteredCount: 0,
    labelCount: "Treffer",
    items: [],
    error: {
        head: "Es liegen keine Bestellungen vor",
        copy:
            "Lernen sie unser umfangreiches Software Portfolio kennen und kontaktieren sie ihren zuständigen Trumpf Ansprechpartner.",
    },
};

const writeToFile = (object: ContentData, name: string) => {
    console.log(JSON.stringify(object));
    fs.writeFileSync(`${output}${name}.json`, JSON.stringify(object));
};

writeToFile(response, "myorders-stateful");
writeToFile(emptyResponse, "myorders-stateful-empty");
